<template>
    <div>
        <div :class="{'wrap1500': $route.name !== '走势图'}" class="wrap1200 breadcrumb">
            <breadcrumb></breadcrumb>
        </div>
        <router-view></router-view>
        <div v-if="$route.name === '走势图'" class="wrap1200">
            <div class="trendLink">
                <div class="trendType">
                    <a @click="goToFcssq('ssqzs')" class="typeLogo">
                        <div class="img">
                            <img src="../assets/new_ssq.png" />
                        </div>
                        <span>双色球走势</span>
                    </a>
                    <div class="list">
                        <h3>号码走势</h3>
                        <ul>
                            <li>
                                <a @click="goToDetails('ssqindex','jbzs')">· 基本走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('ssqindex','lqzs')">· 蓝球走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('ssqindex','dwzs')">· 定位走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('ssqindex','wszs')">· 尾数走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('ssqindex','dxzs')">· 大小走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('ssqindex','jozs')">· 奇偶走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('ssqindex','zhzs')">· 质合走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('ssqindex','csys')">· 除3余数</a>
                            </li>
                            <li>
                                <a @click="goToDetails('ssqindex','hzzs')">· 和值走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('ssqindex','kdzs')">· 跨度走势</a>
                            </li>
                        </ul>
                        <!-- <h3 class="mt20">
                            <span class="mr10">其他走势：</span>
                            <a href="JavaScript:;">历史同期</a>
                            <a href="JavaScript:;" class="red">更多双色球走势图>></a>
                        </h3> -->
                    </div>
                </div>
            </div>
            <div class="trendLink">
                <div class="trendType">
                    <a href="javascript:;" class="typeLogo">
                        <div class="img">
                            <img src="../assets/new_dlt.png" />
                        </div>
                        <span>大乐透走势</span>
                    </a>
                    <div class="list">
                        <h3>号码走势</h3>
                        <ul>
                            <li>
                                <a @click="goToDetails('dltindex','jbzs')">· 基本走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('dltindex','hqzs')">· 后区走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('dltindex','dwzs')">· 定位走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('dltindex','dxzs')">· 大小走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('dltindex','jozs')">· 奇偶走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('dltindex','zhzs')">· 质合走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('dltindex','csys')">· 除3余数</a>
                            </li>
                            <li>
                                <a @click="goToDetails('dltindex','hzzs')">· 和值走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('dltindex','kdzs')">· 跨度走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('dltindex','wszs')">· 尾数走势</a>
                            </li>
                        </ul>
                        <!-- <h3 class="mt20">
                            <span class="mr10">其他走势：</span>
                            <a href="JavaScript:;" class="red">更多双色球走势图>></a>
                        </h3> -->
                    </div>
                </div>
            </div>
            <div class="trendLink">
                <div class="trendType">
                    <a href="javascript:;" class="typeLogo">
                        <div class="img">
                            <img src="../assets/new_fcsd.png" />
                        </div>
                        <span>福彩3D走势</span>
                    </a>
                    <div class="list">
                        <h3>号码走势</h3>
                        <ul>
                            <li>
                                <a @click="goToDetails('fcsdindex','zxzs')">· 直选走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('fcsdindex','zuxzs')">· 组选走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('fcsdindex','dxzs')">· 大小走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('fcsdindex','jozs')">· 奇偶走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('fcsdindex','zhzs')">· 质合走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('fcsdindex','csys')">· 除3余数</a>
                            </li>
                            <li>
                                <a @click="goToDetails('fcsdindex','hzzs')">· 和值走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('fcsdindex','kdzs')">· 跨度走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('fcsdindex','dwzs')">· 定位走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('fcsdindex','zxdw')">· 组选定位</a>
                            </li>
                        </ul>
                        <!-- <h3 class="mt20">
                            <span class="mr10">其他走势：</span>
                            <a href="JavaScript:;" class="red">更多双色球走势图>></a>
                        </h3> -->
                    </div>
                </div>
            </div>
            <div class="trendLink">
                <div class="trendType">
                    <a href="javascript:;" class="typeLogo">
                        <div class="img">
                            <img src="../assets/new_pl3.png" />
                        </div>
                        <span>排列三走势</span>
                    </a>
                    <div class="list">
                        <h3>号码走势</h3>
                        <ul>
                            <li>
                                <a @click="goToDetails('plsindex','zxzs')">· 直选走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plsindex','zuxzs')">· 组选走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plsindex','dxzs')">· 大小走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plsindex','jozs')">· 奇偶走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plsindex','zhzs')">· 质合走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plsindex','csys')">· 除3余数</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plsindex','hzzs')">· 和值走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plsindex','kdzs')">· 跨度走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plsindex','dwzs')">· 定位走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plsindex','zxdw')">· 组选定位</a>
                            </li>
                        </ul>
                        <!-- <h3 class="mt20">
                            <span class="mr10">其他走势：</span>
                            <a href="JavaScript:;" class="red">更多双色球走势图>></a>
                        </h3> -->
                    </div>
                </div>
            </div>
            <div class="trendLink">
                <div class="trendType">
                    <a href="javascript:;" class="typeLogo">
                        <div class="img">
                            <img src="../assets/new_pl5.png" />
                        </div>
                        <span>排列五走势</span>
                    </a>
                    <div class="list">
                        <h3>号码走势</h3>
                        <ul>
                            <li>
                                <a @click="goToDetails('plwindex','zxzs')">· 直选走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plwindex','hzzs')">· 和值走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plwindex','dxjo')">· 大小奇偶</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plwindex','csys')">· 除3余数</a>
                            </li>
                            <li>
                                <a @click="goToDetails('plwindex','dwzs')">· 定位走势</a>
                            </li>
                        </ul>
                        <!-- <h3 class="mt20">
                            <span class="mr10">其他走势：</span>
                            <a href="JavaScript:;" class="red">更多双色球走势图>></a>
                        </h3> -->
                    </div>
                </div>
            </div>
            <div class="trendLink">
                <div class="trendType">
                    <a href="javascript:;" class="typeLogo">
                        <div class="img">
                            <img src="../assets/new_qxc.png" />
                        </div>
                        <span>七星彩走势</span>
                    </a>
                    <div class="list">
                        <h3>号码走势</h3>
                        <ul>
                            <li>
                                <a @click="goToDetails('qxcindex','zxzs')">· 直选走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('qxcindex','hqzs')">· 后区走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('qxcindex','dxzs')">· 大小走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('qxcindex','jozs')">· 奇偶走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('qxcindex','zhzs')">· 质合走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('qxcindex','csys')">· 除3余数</a>
                            </li>
                        </ul>
                        <!-- <h3 class="mt20">
                            <span class="mr10">其他走势：</span>
                            <a href="JavaScript:;" class="red">更多双色球走势图>></a>
                        </h3> -->
                    </div>
                </div>
            </div>
            <div class="trendLink">
                <div class="trendType">
                    <a href="javascript:;" class="typeLogo">
                        <div class="img">
                            <img src="../assets/new_qlc.png" />
                        </div>
                        <span>七乐彩走势</span>
                    </a>
                    <div class="list">
                        <h3>号码走势</h3>
                        <ul>
                            <li>
                                <a @click="goToDetails('qlcindex','jbzs')">· 基本走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('qlcindex','dxzs')">· 大小走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('qlcindex','jozs')">· 奇偶走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('qlcindex','zhzs')">· 质合走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('qlcindex','csys')">· 除3余数</a>
                            </li>
                        </ul>
                        <!-- <h3 class="mt20">
                            <span class="mr10">其他走势：</span>
                            <a href="JavaScript:;" class="red">更多双色球走势图>></a>
                        </h3> -->
                    </div>
                </div>
            </div>
            <div class="trendLink">
                <div class="trendType">
                    <a href="javascript:;" class="typeLogo">
                        <div class="img">
                            <img src="../assets/new_15x5.png" />
                        </div>
                        <span>15选5走势</span>
                    </a>
                    <div class="list">
                        <h3>号码走势</h3>
                        <ul>
                            <li>
                                <a @click="goToDetails('swxwindex','jbzs')">· 基本走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('swxwindex','dxzs')">· 大小走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('swxwindex','jozs')">· 奇偶走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('swxwindex','zhzs')">· 质合走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('swxwindex','csys')">· 除3余数</a>
                            </li>
                        </ul>
                        <!-- <h3 class="mt20">
                            <span class="mr10">其他走势：</span>
                            <a href="JavaScript:;" class="red">更多双色球走势图>></a>
                        </h3> -->
                    </div>
                </div>
            </div>
            <div class="trendLink">
                <div class="trendType">
                    <a href="javascript:;" class="typeLogo">
                        <div class="img">
                            <img src="../assets/new_df61.png" />
                        </div>
                        <span>东方6+1走势</span>
                    </a>
                    <div class="list">
                        <h3>号码走势</h3>
                        <ul>
                            <li>
                                <a @click="goToDetails('df61index','jbzs')">· 基本走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('df61index','dxzs')">· 大小走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('df61index','jozs')">· 奇偶走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('df61index','zhzs')">· 质合走势</a>
                            </li>
                            <li>
                                <a @click="goToDetails('df61index','csys')">· 除3余数</a>
                            </li>
                        </ul>
                        <!-- <h3 class="mt20">
                            <span class="mr10">其他走势：</span>
                            <a href="JavaScript:;" class="red">更多双色球走势图>></a>
                        </h3> -->
                    </div>
                </div>
            </div>
            <div class="trendLink">
                <div class="trendType">
                    <a href="javascript:;" class="typeLogo">
                        <div class="img">
                            <img src="../assets/new_kl8.png" />
                        </div>
                        <span>快乐8走势</span>
                    </a>
                    <div class="list">
                        <h3>号码走势</h3>
                        <ul>
                            <li>
                                <a @click="goToDetails('kl8index','jbzs')">· 基本走势</a>
                            </li>
                        </ul>
                        <!-- <h3 class="mt20">
                            <span class="mr10">其他走势：</span>
                            <a href="JavaScript:;" class="red">更多双色球走势图>></a>
                        </h3> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '../components/Breadcrumb.vue';
export default {
  name: 'App',
  components: {
    Breadcrumb
  },
  data(){
    return{
        tableData: []
    }
  },
  methods:{
    goToDetails(pathName, tabName) {
        this.$router.push({
            path: '/trendChart/' + pathName,
            query: { tab: tabName }
        });
    },
    // goToFcssqJb() {
    //     this.$router.push({ path: '/trendChart/ssqzs' });
    // },
    // goToFcssqLq() {
    //     this.$router.push({ path: '/trendChart/ssqlq' });
    // },
    // goToFcssqDx() {
    //     this.$router.push({ path: '/trendChart/ssqdx' });
    // },
    // goToFcssqJo() {
    //     this.$router.push({ path: '/trendChart/ssqjo' });
    // },
    // goToFcssqZh() {
    //     this.$router.push({ path: '/trendChart/ssqzh' });
    // },
    // goToFcssqC3() {
    //     this.$router.push({ path: '/trendChart/ssqc3' });
    // },
    // goToFcssqHz() {
    //     this.$router.push({ path: '/trendChart/ssqhz' });
    // }
  }
}
</script>
<style scopeds>
.wrap1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}
.mr10 {
    margin-right: 10px;
}
.trendLink {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 10px;
    overflow: hidden;
}
.trendType {
    display: flex;
    align-items: center;
}
.trendType .typeLogo {
    display: block;
    width: 176px;
    text-align: center;
    color: #333;
}
.trendType .typeLogo .img {
    margin: 0 auto;
    width: 80px;
    height: 80px;
    padding: 12px;
    background: #FFF;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 16px;
    border: 1px solid #EEE;
    box-sizing: border-box;
}
.trendType .typeLogo .img img {
    width: 100%;
    height: 100%;
}
.trendType .typeLogo:hover .img {
    border-color: #ccc;
}

.trendType .typeLogo:hover .img img {
    animation: bounceIn .8s ease both;
    -webkit-animation: bounceIn .8s ease both;
}

@keyframes bounceIn {
    from, 20%, 40%, 60%, 80%, to {
        -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
        animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    }

    0% {
        opacity: 1;
        -webkit-transform: scale3d(.3, .3, .3);
        transform: scale3d(.3, .3, .3);
    }

    20% {
        -webkit-transform: scale3d(1.2, 1.2, 1.2);
        transform: scale3d(1.2, 1.2, 1.2);
    }

    40% {
        -webkit-transform: scale3d(.9, .9, .9);
        transform: scale3d(.9, .9, .9);
    }

    60% {
        opacity: 1;
        -webkit-transform: scale3d(1.03, 1.03, 1.03);
        transform: scale3d(1.03, 1.03, 1.03);
    }

    80% {
        -webkit-transform: scale3d(.97, .97, .97);
        transform: scale3d(.97, .97, .97);
    }

    to {
        opacity: 1;
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
}
.downColumn .downBtn, .trendType .typeLogo .img, .trendType.form .typeLogo {
    -webkit-transition: all .2s ease;
    -moz-transition: all .2s ease;
    -o-transition: all .2s ease;
    -ms-transition: all .2s ease;
    transition: all .2s ease;
}
.trendType .typeLogo span {
    display: block;
    font-size: 16px;
    line-height: 22px;
    font-weight: 800;
    margin-top: 10px;
}
.trendType .list {
    padding: 20px 0 20px 8px;
    flex: 1;
}
.trendType .list h3 {
    font-size: 14px;
    font-weight: 800;
}
.trendType .list ul {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
}
.trendType ul li {
    margin-right: 30px;
    margin-top: 10px;
    min-width: 92px;
}
.trendType ul li a {
    line-height: 20px;
    color: #333;
    font-size: 14px;
}
.trendType ul li a:hover {
    text-decoration: underline;
}
.mt20 {
    margin-top: 20px;
}
.trendType .list h3 a:hover {
    text-decoration: underline;
}
.trendType .list h3 a {
    font-size: 14px;
    margin-right: 30px;
    font-weight: 500;
    color: #333;
}
.trendType .list h3 a.red {
    color: #EA4747;
}
</style>


// WEBPACK FOOTER //
// src/views/trendChart.vue